import { render, staticRenderFns } from "./StorageReport.vue?vue&type=template&id=260dd317&scoped=true"
import script from "./StorageReport.vue?vue&type=script&lang=js"
export * from "./StorageReport.vue?vue&type=script&lang=js"
import style0 from "./StorageReport.vue?vue&type=style&index=0&id=260dd317&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260dd317",
  null
  
)

export default component.exports